// src/components/FDMIS.jsx
import React, { useEffect, useRef, useState } from "react";
import { FaIdBadge, FaUser, FaUserFriends } from "react-icons/fa";
import Select from "react-select";
import "./FDD.css"; // keep your styles
import { Chart as ChartJS } from "chart.js/auto";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const FDMIS = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((s) => s.userProfile || {});
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  // ====== UI / Loading states ======
  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [nomineeLoading, setNomineeLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // ====== Schemes & accounts ======
  const [schemes, setSchemes] = useState([]);
  const [loadingSchemes, setLoadingSchemes] = useState(false);
  const [savingAccounts, setSavingAccounts] = useState([]);

  // ====== Form states ======
  const [accountType, setAccountType] = useState("FD"); // "FD" or "MIS"
  const [selectedSchemeId, setSelectedSchemeId] = useState("");
  const [selectedScheme, setSelectedScheme] = useState(null);

  const [amount, setAmount] = useState(""); // deposit amount
  const [tenure, setTenure] = useState(""); // months
  const [payoutType, setPayoutType] = useState("On Maturity");
  const [payoutFrequency, setPayoutFrequency] = useState(""); // for MIS
  const [deductionType, setDeductionType] = useState("manual");
  const [selectedSavingAccount, setSelectedSavingAccount] = useState(null);
  const [relation,setRelation]=useState("")

  // customer/nominee/referral
  const [customerId, setCustomerId] = useState("");
     const [customers,setCustomers]=useState([])
      const [selectedCustomer,setSelectedCustomer]=useState(null);
  const [customerData, setCustomerData] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
    aadhar: "",
    pan: "",
    dob: "",
    address: "",
  });

  const [nomineeId, setNomineeId] = useState("");
  const [nomineeData, setNomineeData] = useState({
    nomineeName: "",
    dob: "",
    aadhar: "",
    pan: "",
    mobile: "",
    nomineeRelation: "",
  });

  const [referId, setReferId] = useState("");
  const [referralData,setReferralData]=useState("");
  const [referralName, setReferralName] = useState("");
  const [openingDate,setOpeningDate]= useState(null);
  const [bonus,setbonus]=useState(0);

  // calculation results (keep as numbers)
  const [results, setResults] = useState({
    principal: 0,
    totalInterest: 0,
    maturityAmount: 0,
    monthlyInterest: 0,
  });

  // chart toggle
  const [viewChart, setViewChart] = useState(false);

  // ====== Fetch user profile on mount ======
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // ====== Fetch schemes when profile loaded ======
  useEffect(() => {
    if (!profile?.superAdminId) return;

    const fetchSchemes = async () => {
      setLoadingSchemes(true);
      try {
        const res = await axios.get(
          `https://payyug.in/api/get-all-fdmis?superAdminId=${profile.superAdminId}`
        );
        if (res.data?.success) {
          setSchemes(Array.isArray(res.data.data) ? res.data.data : []);
        } else {
          setSchemes([]);
          console.warn("Schemes fetch responded but success=false", res.data);
        }
      } catch (err) {
        console.error("Error fetching schemes:", err?.response?.data || err);
        setSchemes([]);
      } finally {
        setLoadingSchemes(false);
      }
    };

    fetchSchemes();
  }, [profile?.superAdminId]);

  // ====== Fetch saving accounts if deductionType === 'linked' ======
  const fetchSavingAccounts = async () => {
    if (!profile?.superAdminId) return;
    const branchId = Number(profile?.branchId) || Number(localStorage.getItem("userId")) || 56;

    try {
      const res = await axios.get("https://payyug.in/api/get-all-saving-account", {
        params: { superAdminId: profile.superAdminId, branchId },
      });
      if (Array.isArray(res.data.accounts)) setSavingAccounts(res.data.accounts);
      else setSavingAccounts([]);
    } catch (err) {
      console.error("Error fetching saving accounts:", err?.response?.data || err);
      setSavingAccounts([]);
    }
  };

  useEffect(() => {
    if (deductionType === "linked") fetchSavingAccounts();
  }, [deductionType, profile?.superAdminId]);

  // ====== Scheme select handler ======
  const handleSchemeSelect = (e) => {
    const id = e.target.value;
    setSelectedSchemeId(id);
    const found = schemes.find((s) => Number(s.id) === Number(id));
    setSelectedScheme(found || null);
  };


      useEffect(() => {
        if (selectedCustomer) {
          setCustomerId(selectedCustomer.userId)
          setCustomerData((prev) => ({
            ...prev,
            id: selectedCustomer.id || "",
            name: selectedCustomer.fullName || "",
            email: selectedCustomer.email || "",
            phone: selectedCustomer.mobileNumber || "",
            aadhar: selectedCustomer.aadhaarNumber || "",
            pan: selectedCustomer.panNumber || "",
            address: selectedCustomer.address || "",
            dob: selectedCustomer.dateOfBirth ? selectedCustomer.dateOfBirth.split("T")[0] : "",
          
          }));
        } else if (!customerData.userId) {
          setCustomerData({
            userId: "",
            name:  "",
            email:  "",
            phone:"",
            aadhar:"",
            pan:"",
            address:"",
            dob:"",
          });
        }
      }, [selectedCustomer, customerData.userId]);

          const fetchCustomer = async () => {
              try {
                const res = await axios.get(`https://payyug.in/api/customers`, {
                  params: {
                    branchId: profile.id || 8,
                    // superAdminId: profile.superAdminId || 14,
                    page:1,
                    limit:1000
                  }
                });
                setCustomers(res.data.data || []);
              } catch (err) {
                toast.error(err?.response?.data?.message || "Failed to fetch customers");
              }
            };
      
              useEffect(() => {
          if (profile) fetchCustomer();
        }, [profile]);



  const fetchNominee = async () => {
    if (!customerId) return;
    try {
      setNomineeLoading(true);
      const branchId = localStorage.getItem("userId") || "56";
      const res = await axios.get(
        "https://payyug.in/api/customer-nominee-filter",
        {
          params: { customerId, branchId },
        }
      );

      if (res.data.success && res.data.data) {
        const n = res.data.data;
        console.log("nominee data:", n);
        setNomineeData({
        nomineeName: n.nomineeName || "",
        dob: n.nomineeDob ? n.nomineeDob.split("T")[0] : "",
        aadhar: n.nomineeAadhar || "",
        pan: n.nomineePan || "",
        mobile: n.nomineeMobile || "",
        nomineeRelation: n.nomineeRelation || n.relation || "",
        id:n.id,
      });
      setNomineeId(n.accountId || "");
      setRelation(n.nomineeRelation || n.relation || "");
      } else {
        setNomineeData({
        nomineeName: "",
        dob: "",
        aadhar: "",
        pan: "",
        mobile: "",
        nomineeRelation: "",
      });
      setNomineeId("");
      setRelation("");
      }
    } catch (err) {
      console.error("Error fetching nominee:", err);
      toast.error("Error fetching nominee details");
    } finally {
      setNomineeLoading(false);
    }
  };

  useEffect(()=>{
    if(customerId){
      fetchNominee()
    }
  },[customerId])


  // ====== Fetch Referral ======
const fetchReferral = async (id) => {
  if (!id) return alert("Please enter Referral ID");

  try {
    const superAdminId = profile?.superAdminId;
    const res = await axios.get("https://payyug.in/api/hr-employees-filter", {
      params: { userId: id, superAdminId },
    });

    const r = res?.data?.data;
    console.log("referal data:",r.id)
    if (res.data?.success && r) {
      setReferralName(r.fullName || r.employeeName || r.name || "");
      setReferralData(r.id);
    } else {
      setReferralName("");
      toast.error("No referral found with this ID");
    }
  } catch (err) {
    console.error("Error fetching referral:", err?.response?.data || err);
    toast.error("Error fetching referral details");
    setReferralName("");
  }
};


  // ====== Auto-fetch customer & nominee when customerId pattern matches ======
  // useEffect(() => {
  //   const pattern = /^CUS\d{3,10}$/; // adjust pattern as per your IDs
  //   if (!customerId) return;
  //   // if you want auto-fetch only when pattern matches:
  //   if (pattern.test(customerId)) {
  //     fetchCustomer(customerId);
  //     fetchNominee(customerId);
  //   } else {
  //     // still allow manual fetch if you want:
  //     // fetchCustomer(customerId);
  //   }
  // }, [customerId]);

  // ====== Auto-fetch referral when referId looks valid ======
  useEffect(() => {
    if (!referId || !profile?.superAdminId) return;
    const pattern = /^[A-Z.\-]{2,10}\d{1,10}$/;
    if (pattern.test(referId)) fetchReferral(referId);
  }, [referId, profile?.superAdminId]);

  // ====== Calculation ======
  const handleCalculate = (e) => {
    e.preventDefault();

    if (!amount || !tenure || !selectedScheme) {
      toast.warn("Please select a scheme and enter amount & tenure");
      return;
    }

    const P = Number(amount);
    const R = Number(selectedScheme.roi || selectedScheme?.roi || 0);
    const n = Number(tenure);
    const r = R / 100;
    // console.log("so these are the values....",P,R,n,r);

    if (!P || !R || !n) {
      toast.warn("Invalid input values");
      return;
    }

    let maturity = 0;
    let totalInterest = 0;
    let monthlyInterest = 0;

    // if (accountType === "FD") {
    //   // monthly compounding assumption if roiFrequency monthly
    //   maturity = P * Math.pow(1 + r / 12, n);
    //   totalInterest = maturity - P;
    //   monthlyInterest = (totalInterest / n).toFixed(2);
    // } 
    
     if (accountType === "FD") {
        const compoundingMap = {
          Monthly: 12,
          Quarterly: 4,
          Yearly: 1,
        };

        const compounding =
          compoundingMap[selectedScheme?.interestCompounding] ?? 12;
      //  console.log("compounidng is ", compounding);
        const years = n / 12; // because tenure is in months
        // console.log("years are ",years);
        maturity = P * Math.pow(1 + r / compounding, compounding * years);
        // console.log("maturity amount is ", maturity);

        totalInterest = maturity - P;

        // average monthly earning (for display only)
        monthlyInterest = totalInterest / n;
      }
    else {
      // MIS: monthly payout interest; principal stays same
      monthlyInterest = (P * r) / 12;
      totalInterest = monthlyInterest * n;
      maturity = P;
    }

    setResults({
      principal: Number(P.toFixed(2)),
      totalInterest: Number(Number(totalInterest).toFixed(2)),
      maturityAmount: Number(Number(maturity).toFixed(2)),
      monthlyInterest: Number(Number(monthlyInterest).toFixed(2)),
    });

    // auto open chart after calculation
    setViewChart(true);
  };

  // ====== Chart rendering ======
  useEffect(() => {
    if (!viewChart || !canvasRef.current) return;

    try {
      // destroy previous
      if (chartRef.current) {
        try {
          chartRef.current.destroy();
        } catch (e) {
          // ignore
        }
      }

      chartRef.current = new ChartJS(canvasRef.current, {
        type: "doughnut",
        data: {
          labels: ["Principal", "Interest"],
          datasets: [
            {
              data: [results.principal || 0, results.totalInterest || 0],
              backgroundColor: ["#018da0ff", "#F59E0B"],
              hoverOffset: 10,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: { legend: { position: "bottom" } },
        },
      });
    } catch (err) {
      console.error("Chart error:", err);
    }

    return () => {
      try {
        if (chartRef.current) chartRef.current.destroy();
      } catch (e) {}
    };
  }, [viewChart, results]);

  // ====== Reset form ======
  const resetForm = () => {
    setAmount("");
    setTenure("");
    setResults({ principal: 0, totalInterest: 0, maturityAmount: 0, monthlyInterest: 0 });
    setViewChart(false);
    setCustomerId("");
    setCustomerData({ name: "", email: "", phone: "", aadhar: "", pan: "", dob: "", address: "" });
    setNomineeId("");
    setNomineeData({ nomineeName: "", dob: "", aadhar: "", pan: "", mobile: "", nomineeRelation: "" });
    // setRelation && setRelation(""); // if relation exists earlier
    setReferId("");
    setReferralName("");
    setSelectedSchemeId("");
    setSelectedScheme(null);
    setDeductionType("manual");
    setSelectedSavingAccount("");
  };

  // ====== Submit (open deposit) ======
const handleSubmit = async () => {
  // ===== Basic Validations =====
  if (!customerId) return alert("Select Customer");
  if (!selectedSchemeId) return alert("Select Scheme");
  if (!amount) return alert("Enter Amount");
  if (!profile?.superAdminId) return alert("Wait loading profile");


  // ===== Final Payload (Matches Backend Exactly) =====
  // const payload = {
  //   accountType: accountType || "",
  //   customerId: Number(customerData.id) || null,
  //   nomineeId: nomineeData?.id ? Number(nomineeData.id) : null,
  //   schemeId: Number(selectedSchemeId) || null,
  //   depositAmount: Number(amount) || null,
  //   tenureMonths: Number(tenure) || null,
  //   payoutType: payoutType || "",
  //   interestPayoutFrequency:
  //     selectedScheme?.roiFrequency || payoutFrequency || "",
  //   compoundingType: selectedScheme?.interestCompounding || "",
  //   bonus: 0,
  //   deductionType: deductionType || "manual",
  //   linkedSavingAccount:
  //     deductionType === "linked" ? Number(selectedSavingAccount.id) : null,
  //   referralId: Number(referralData) || null,
  //   referralName: referralName || "",
  //   branchId:
  //     Number(profile?.branchId) ||
  //     Number(localStorage.getItem("userId")) ||
  //     null,
  //   superAdminId: Number(profile?.superAdminId) || null,
  //   createdBy: Number(localStorage.getItem("userId")) || null,
  //   openingDate: openingDate || new Date().toISOString().split("T")[0],
  // };

  const payload = {
    accountType: accountType || "",
    customerId: Number(customerData.id) || null,
    nomineeId: nomineeData ? Number(nomineeData.id) : null,
    schemeId: Number(selectedSchemeId) || null,
    depositAmount: Number(amount) || 0,
    tenureMonths: Number(tenure) || 0,

    // Matches your payload: "maturity" or frequency
    // payoutType: accountType === "FD" ? "maturity" : payoutFrequency.toLowerCase(),
    payoutType: payoutType || "",
    interestPayoutFrequency: selectedScheme?.roiFrequency || payoutFrequency || "",
    compoundingType: selectedScheme?.interestCompounding || "",

    // Interest details (Calculated in handleCalculate)
    maturityAmount: Number(results.maturityAmount) || 0,
    maturityAmountWithBonus: Number(results.maturityAmount+bonus) || 0,
    totalInterest: Number(results.totalInterest) || 0,
    monthlyInterest: Number(results.monthlyInterest) || 0,
    bonus: bonus, // Set as per your business logic

    // Deduction logic
    deductionType: deductionType || "manual",
    linkedSavingAccount: deductionType === "linked" && selectedSavingAccount 
      ? Number(selectedSavingAccount.id) 
      : null,

    // Referral & Auth info
    referralId: Number(referralData) || null,
    referralName: referralName || "",
    branchId: Number(profile?.branchId) || Number(localStorage.getItem("userId")),
    superAdminId: Number(profile?.superAdminId) || null,
    createdBy: Number(profile?.userId) || Number(localStorage.getItem("userId")),
    openingDate: openingDate || new Date().toISOString().split("T")[0],
  };



  console.log("Payload being sent:", payload);

  // ===== API Call =====
  try {
    setSubmitting(true);

    const res = await axios.post(
      "https://payyug.in/api/fdmis/create",
      payload
    );

    if (res.data?.success) {
      toast.success(res?.data?.message||"Deposit created");
      resetForm();
    } else {
      toast.error(res.data?.message || "Failed to create deposit");
    }
  } catch (err) {
    console.error("Error creating deposit:", err?.response?.data || err);
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Server error";
    toast.error(`Error: ${msg}`);
  } finally {
    setSubmitting(false);
  }
};



  // ====== Render ======
  return (
    <div className="fd-mis-container">
      {/* Top FD/MIS Grid */}
      <h2 className="fd-mis-heading">
        {accountType === "FD"
          ? "FD Account Form"
          : "MIS Account Form"}
      </h2 >
      <form onSubmit={handleCalculate} style={{ marginBottom: 20 }}>
        <h2 className="fd-mis-h2">ACCOUNT INFORMATION</h2>
        <div className="fd-mis-form-grid">
          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Account Type :</label>
            <select value={accountType} onChange={(e) => setAccountType(e.target.value)} className="fd-mis-input">
              <option value="FD">FD</option>
              <option value="MIS">MIS</option>
            </select>
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Select Scheme :</label>
            <select className="fd-mis-input" value={selectedSchemeId} onChange={handleSchemeSelect}>
              <option value="">-- Select Scheme --</option>
              {loadingSchemes ? (
                <option disabled>Loading...</option>
              ) : (
                schemes.map((scheme) => (
                  <option key={scheme.id} value={scheme.id}>
                    {scheme.serviceName} ({scheme.roiFrequency})
                  </option>
                ))
              )}
            </select>
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">ROI (%) :</label>
            <input className="fd-mis-input" value={selectedScheme?.roi ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Min Deposit Amount :</label>
            <input className="fd-mis-input" value={selectedScheme?.minDepositAmount ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Min Tenure :</label>
            <input className="fd-mis-input" value={selectedScheme?.minTenure ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">ROI Frequency :</label>
            <input className="fd-mis-input" value={selectedScheme?.roiFrequency ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Lockin Period (Months):</label>
            <input className="fd-mis-input" value={selectedScheme?.depositLockinPeriod ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Interest Lockin (Months):</label>
            <input className="fd-mis-input" value={selectedScheme?.interestLockinPeriod ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Compounding Type :</label>
            <input className="fd-mis-input" value={selectedScheme?.interestCompounding ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Enter Deposit Amount :</label>
            <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="fd-mis-input" />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Enter Tenure (Months) :</label>
            <input type="number" value={tenure} onChange={(e) => setTenure(e.target.value)} className="fd-mis-input" />
          </div>
        
          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Opening Date :</label>
            <input 
              type="date" 
              value={openingDate} 
              onChange={(e) => setOpeningDate(e.target.value)} 
              className="fd-mis-input" 
            />
          </div>

          {accountType === "MIS" && (
            <>
              <div className="fd-mis-input-fields">
                <label className="fd-mis-label">Interest Payout Frequency :</label>
                <select value={payoutFrequency} onChange={(e) => setPayoutFrequency(e.target.value)} className="fd-mis-input">
                  <option value="">Select</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Quarterly">Quarterly</option>
                </select>
              </div>

              <div className="fd-mis-input-fields">
                <label className="fd-mis-label">Monthly Interest :</label>
                <input className="fd-mis-input" readOnly value={results.monthlyInterest ?? 0} />
              </div>
            </>
          )}
        </div>

        <div className="fd-mis-actions">
          <button type="submit" className="fd-mis-calc">
            Calculate
          </button>
          <button type="button" className="fd-mis-reset" onClick={resetForm}>
            Reset
          </button>

          {/* <label className="fd-mis-chart-toggle">
            <input type="checkbox" checked={viewChart} onChange={(e) => setViewChart(e.target.checked)} />
            <span className="fd-mis-slider"></span>
            <span className="fd-mis-toggle-label">{viewChart ? "View" : "Close"} Chart</span>
          </label> */}
        </div>
      </form>

      {/* Results */}
      <div className="fd-mis-results-container card">
        <div className="fd-mis-results-card-header">Results</div>
        <div className="fd-mis-results-card-grid">
          <div className="fd-mis-results-card-info">
            <div className="fd-mis-results-card-row">
              <div className="fd-mis-results-card-label">Principal Amount:</div>
              <div className="fd-mis-results-card-value">{Number(results.principal || 0).toLocaleString()}</div>
            </div>
            <div className="fd-mis-results-card-row">
              <div className="fd-mis-results-card-label">Total Interest:</div>
              <div className="fd-mis-results-card-value">{Number(results.totalInterest || 0).toLocaleString()}</div>
            </div>
            <div className="fd-mis-results-card-row">
              <div className="fd-mis-results-card-label">Maturity Amount:</div>
              <div className="fd-mis-results-card-value">{Number(results.maturityAmount || 0).toLocaleString()}</div>
            </div>

            {accountType === "MIS" && (
              <div className="fd-mis-results-card-row">
                <div className="fd-mis-results-card-label">Monthly Interest:</div>
                <div className="fd-mis-results-card-value">{Number(results.monthlyInterest || 0).toLocaleString()}</div>
              </div>
            )}
          </div>

          {/* {viewChart && (
            <div className="fd-mis-chart-wrap">
              <canvas ref={canvasRef} className="fd-mis-canvas" />
            </div>
          )} */}
        </div>
      </div>

      {/* CUSTOMER / NOMINEE / REFERRAL */}
      <div className="fd-mis-customer-contaier">
        <h3 className="fd-mis-h3">
          <FaUser /> Customer Details
        </h3>

        <div className="fd-mis-cn-row-box">
          <div className="fd-mis-cn-label-cell">Customer ID:</div>
          <div className="fd-mis-cn-value-cell">
            {/* <input placeholder="Enter Customer ID" value={customerId} onChange={(e) => setCustomerId(e.target.value)} /> */}
             <Select
              className="account-select-container"
              classNamePrefix="account-select"
              placeholder="Search Customer Id"
              options={customers.map((cus) => ({
                value: cus.id,
                label: `${cus.userId} | ${cus.fullName}`,
                customerDetail: cus,
              }))}
               value={
                selectedCustomer
                  ? {
                      value: selectedCustomer.id,
                      label: `${selectedCustomer.userId} | ${selectedCustomer.fullName}`,
                    }
                  : null
              }
              onChange={(selected) => setSelectedCustomer(selected?.customerDetail)}
              isSearchable
              />
          </div>

          <div className="fd-mis-cn-label-cell">User Name:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="User Name" value={customerData.name} onChange={(e) => setCustomerData({ ...customerData, name: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Email:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Email" value={customerData.email} onChange={(e) => setCustomerData({ ...customerData, email: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Phone:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Phone" value={customerData.phone} onChange={(e) => setCustomerData({ ...customerData, phone: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Aadhar:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Aadhar" value={customerData.aadhar} onChange={(e) => setCustomerData({ ...customerData, aadhar: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">PAN:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="PAN" value={customerData.pan} onChange={(e) => setCustomerData({ ...customerData, pan: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Date of Birth:</div>
          <div className="fd-mis-cn-value-cell">
            <input type="date" value={customerData.dob} onChange={(e) => setCustomerData({ ...customerData, dob: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Address:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Address" value={customerData.address} onChange={(e) => setCustomerData({ ...customerData, address: e.target.value })} />
          </div>
        </div>

        {customerLoading && <p className="FDloading-text">Loading customer data...</p>}
      </div>

      {/* NOMINEE */}
      <div className="fd-mis-nominee-container">
        <h3 className="fd-mis-h3">
          <FaUserFriends /> Nominee Details
        </h3>

        <div className="fd-mis-cn-row-box">
          <div className="fd-mis-cn-label-cell">Nominee ID:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Enter Nominee ID" value={nomineeId} onChange={(e) => setNomineeId(e.target.value)} />
          </div>

          <div className="fd-mis-cn-label-cell">Nominee Name:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Nominee Name" value={nomineeData.nomineeName} onChange={(e) => setNomineeData({ ...nomineeData, nomineeName: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">DOB:</div>
          <div className="fd-mis-cn-value-cell">
            <input type="date" value={nomineeData.dob} onChange={(e) => setNomineeData({ ...nomineeData, dob: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Aadhar:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Aadhar" value={nomineeData.aadhar} onChange={(e) => setNomineeData({ ...nomineeData, aadhar: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">PAN:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="PAN" value={nomineeData.pan} onChange={(e) => setNomineeData({ ...nomineeData, pan: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Mobile:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Mobile" value={nomineeData.mobile} onChange={(e) => setNomineeData({ ...nomineeData, mobile: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Relation:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Relation" value={nomineeData.nomineeRelation} onChange={(e) => setNomineeData({ ...nomineeData, nomineeRelation: e.target.value })} />
          </div>
        </div>

        {nomineeLoading && <p className="FDloading-text">Loading nominee data...</p>}

        {/* Deduction Type Selector */}
        <div className="fd-mis-deduction-field">
          <label className="fd-mis-deduction-label">Deduction Type:</label>
          <select value={deductionType} onChange={(e) => setDeductionType(e.target.value)} className="fd-mis-deduction-input">
            <option value="manual">Manual Deposit</option>
            <option value="linked">Deduct from Saving Account</option>
          </select>
        </div>

        {/* Show Saving Account Dropdown if Linked Selected */}
        {/* {deductionType === "linked" && (
          <div className="fd-mis-deduction-field">
            <label className="fd-mis-deduction-label">Select Saving Account:</label>
            <select value={selectedSavingAccount} onChange={(e) => setSelectedSavingAccount(e.target.value)} className="fd-mis-deduction-input">
              <option value="">-- Select Saving Account --</option>
              {savingAccounts.map((acc) => (
                <option key={acc.id} value={acc.id}>
                  {acc.accountNumber}-{acc.customerName}—₹{Number(acc.currentBalance || 0).toLocaleString()}
                </option>
              ))}
            </select>
          </div>
        )} */}
        {deductionType === "linked" && (
          <div className="fd-mis-deduction-field">
            <label className="fd-mis-deduction-label">
              Select Saving Account:
            </label>

            <Select
              className="account-select-container"
              classNamePrefix="account-select"
              placeholder="Search saving account..."
              options={savingAccounts.map((acc) => ({
                value: acc.id,
                label: `${acc.accountNumber} | ${acc.customerName} | ₹${Number(
                  acc.currentBalance || 0
                ).toLocaleString()}`,
                account: acc,
              }))}
              value={
                selectedSavingAccount
                  ? {
                      value: selectedSavingAccount.id,
                      label: `${selectedSavingAccount.accountNumber} | ${selectedSavingAccount.customerName} | ₹${selectedSavingAccount.currentBalance}`,
                    }
                  : null
              }
              onChange={(selected) =>
                setSelectedSavingAccount(selected?.account || null)
              }
              isSearchable
            />
          </div>
        )}
      </div>

      {/* REFERRAL */}
      <div className="fd-mis-referral-container">
        <h3 className="fd-mis-h3">
          <FaIdBadge /> Referral Details
        </h3>

        <div className="fd-mis-referal-row">
          <div className="fd-mis-referal-column">
            <label>Referral ID</label>
            <input placeholder="Enter Referral ID" value={referId} onChange={(e) => setReferId(e.target.value)} />
          </div>
          <div className="fd-mis-referal-column">
            <label>Referral Name</label>
            <input placeholder="Referral Name" value={referralName} readOnly />
          </div>
        </div>

      </div>
        <div style={{textAlign: "center" }}>
          <button type="button" className="fd-mis-referal-submit-btn" disabled={submitting} onClick={handleSubmit}>
            {submitting ? "Opening..." : `Open ${accountType} Account`}
          </button>
        </div>
    </div>
  );
};

export default FDMIS;
